module.exports = __webpack_public_path__ + "img/1.18.A.0324298d.png";